export default {
    userPackageReadAllBegin(state) {
        state.loading = true;
    },
    
    userPackageReadAllSuccess(state, data) {
        state.loading = false;
        state.data = data.list;
        state.total = data.total ? data.total : 0;
    },
    
    userPackageReadAllErr(state, err) {
        state.loading = false;
        state.error = err;
    },

    userPackageAddBegin(state) {
        state.loading = true;
    },

    userPackageAddSuccess(state) {
        state.loading = false;
    },

    userPackageAddErr(state, err) {
        state.loading = false;
        state.error = err;
    },

    userPackageUpdateBegin(state) {
        state.loading = true;
    },

    userPackageUpdateSuccess(state) {
        state.loading = false;
    },

    userPackageUpdateErr(state, err) {
        state.loading = false;
        state.error = err;
    },

    packageReadAllSuccess(state, data) {
        state.loading = false;
        state.packages = data.list;
    },

    userReadAllBegin(state) {
        state.loadingUsers = true;
    },

    userReadAllSuccess(state, data) {
        state.loadingUsers = false;

        const userList = data.list.map(user => {
            return {
                label: `${user.firstName} ${user.lastName}`,
                value: user.id
            };
        });

        state.users = userList || [];
    },

    userReadAllErr(state, err) {
        state.loadingUsers = false;
        state.error = err;
    },
};